import { businessProfileFieldGroup, businessProfileSubmissionProblems, callerIdNameProblem, maximumCallerIdNameLength, optInMethods, } from "./business-profile";
export const businessProfileSteps = ["business", "address", "representative"];
export const businessProfileStepLabels = {
    business: "Business",
    address: "Address",
    representative: "Representative",
};
const stepsByDetailsField = {
    legalName: "business",
    doingBusinessAs: "business",
    businessType: "business",
    ein: "business",
    website: "business",
    socialPage: "business",
    address: "address",
    representative: "representative",
    secondRepresentative: "representative",
    optInMethods: null,
    sampleMessages: null,
    privacyPolicyUrl: null,
    privacyPolicyStatements: null,
    callerIdName: null,
    industry: null,
};
export const optInMethodLabels = {
    call: "They tell us on a phone call or in person",
    webform: "They fill out a form on our website",
    paper: "They fill out a paper form",
    inbound: "They text or call us first",
};
const optInSentences = {
    call: "Families give their mobile number to an advisor during a phone call or an in-person visit and agree to get texts about their search.",
    webform: "Families enter their mobile number on the contact form on our website, which says they agree to receive texts from us.",
    paper: "Families write their mobile number on our intake form, which says they agree to receive texts from us.",
    inbound: "Families text or call our number first, and we reply to them.",
};
export const privacyPolicyStatementLabels = {
    noShare: "It says you won't share or sell mobile numbers",
    frequency: 'It says how often you text, for example "message frequency varies"',
    rates: 'It says "message and data rates may apply"',
};
export const suggestedPrivacyPolicyWording = "We do not share or sell mobile phone numbers or text messaging consent with third parties for marketing purposes. If you give us your mobile number, we may text you about your senior living search. Message frequency varies. Message and data rates may apply. Reply STOP to stop receiving texts or HELP for help.";
export const businessProfileStepForField = (field) => businessProfileFieldGroup(stepsByDetailsField, field);
export const businessProfileStepProblem = (details, step) => {
    const problem = Object.entries(businessProfileSubmissionProblems(details)).find(([field]) => businessProfileStepForField(field) === step);
    return problem ? problem[1] : null;
};
export const completedBusinessProfileSteps = (details) => businessProfileSteps.filter(step => businessProfileStepProblem(details, step) === null);
export const businessProfileProgress = (status, details) => {
    switch (status) {
        case "draft":
            return completedBusinessProfileSteps(details).length ===
                businessProfileSteps.length
                ? "readyForReview"
                : "inProgress";
        case "submitted":
            return "submitted";
    }
    const exhaustiveCheck = status;
    throw new Error(`Unhandled business profile status: ${exhaustiveCheck}`);
};
const shortenToWholeWords = (value) => {
    let shortened = value;
    while (shortened.length > maximumCallerIdNameLength && shortened.includes(" ")) {
        shortened = shortened.slice(0, shortened.lastIndexOf(" "));
    }
    return shortened.slice(0, maximumCallerIdNameLength).replace(/[., ]+$/, "");
};
export const suggestCallerIdName = (name) => {
    const abbreviated = name
        .replace(/\bSenior\b/gi, "SR")
        .replace(/\bAdvisors?\b/gi, "ADV")
        .replace(/\bPlacement\b/gi, "PLCMT")
        .replace(/\b(LLC|Inc)\b\.?/gi, "")
        .toUpperCase()
        .replace(/[^A-Z0-9., ]/g, "")
        .replace(/\s+/g, " ")
        .trim();
    const suggestion = shortenToWholeWords(abbreviated);
    return suggestion && callerIdNameProblem(suggestion) === null ? suggestion : null;
};
export const optInDescription = (methods) => optInMethods
    .filter(method => methods.includes(method))
    .map(method => optInSentences[method])
    .join(" ");
export const formatEin = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 9);
    return digits.length > 2 ? `${digits.slice(0, 2)}-${digits.slice(2)}` : digits;
};
//# sourceMappingURL=business-profile-wizard.js.map